import React from 'react';
import { useNotionContext } from '../context';
export var Button = function (_a) {
    var _b, _c, _d, _e;
    var block = _a.block;
    var recordMap = useNotionContext().recordMap;
    var automationId = (_b = block === null || block === void 0 ? void 0 : block.format) === null || _b === void 0 ? void 0 : _b.automation_id;
    var automationActions = recordMap.automation_action;
    var automation = (_d = (_c = recordMap === null || recordMap === void 0 ? void 0 : recordMap.automation) === null || _c === void 0 ? void 0 : _c[automationId]) === null || _d === void 0 ? void 0 : _d.value;
    if (!automationId || !automation)
        return null;
    var name = ((_e = automation === null || automation === void 0 ? void 0 : automation.properties) === null || _e === void 0 ? void 0 : _e.name) || 'Untitled';
    var actions = (automation.action_ids || []).map(function (id) { var _a; return (_a = automationActions[id]) === null || _a === void 0 ? void 0 : _a.value; });
    var handleOnClick = function () {
        var _a, _b;
        for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
            var action = actions_1[_i];
            switch (action === null || action === void 0 ? void 0 : action.type) {
                case 'open_page': {
                    // just open a page.
                    var target = (_a = action === null || action === void 0 ? void 0 : action.config) === null || _a === void 0 ? void 0 : _a.target;
                    if ((target === null || target === void 0 ? void 0 : target.type) == 'page') {
                        var pageID = (_b = target === null || target === void 0 ? void 0 : target.page) === null || _b === void 0 ? void 0 : _b.id;
                        window.open(pageID, '_newtab');
                    }
                }
            }
        }
    };
    return (React.createElement("div", { className: 'notion-button-container' },
        React.createElement("button", { className: 'notion-button', onClick: handleOnClick }, name)));
};
//# sourceMappingURL=button.js.map